<template>
  <div>
    <v-app id="inspire">
      <v-content>
        <v-row align="center" justify="center">
          <v-col sm="11" xs="11" md="11" lg="10" xl="10">
            <v-toolbar color="secondary">
              <v-toolbar-title>Clientes</v-toolbar-title>
              <v-spacer></v-spacer>
              <c-formulario-clientes
                @carregarDados="carregarDados(baseUrl)"
                :dialog="dialog"
                :urlPost="baseUrl"
                :usuarioEditado="clienteAtualizado"
              ></c-formulario-clientes>
            </v-toolbar>
            <c-lista-usuarios
              @deletar="modalExcluir($event)"
              @editar="editarCliente($event)"
              :carregando="carregando"
              :headers="headers"
              :itens="cliente"
            ></c-lista-usuarios>
          </v-col>
        </v-row>
      </v-content>
    </v-app>

    <!--Modal para excluir-->
    <c-dialog-excluir
      :loaderExcluir="loaderExcluirUsuarioCliente"
      :dialogModalExcluir="dialogModalExcluir"
      :txtModal="txtModal"
      @fecharDialog="dialogModalExcluir = false"
      @apagarRevendedor="apagarCliente()"
    ></c-dialog-excluir>
    <!--The end-->
  </div>
</template>

<script>
import { apagar, receber } from "../mixins/RequisicaoMixin.js";
import { headersPadrao } from "../mixins/HeadersMixin.js";
import ListaUsuarios from "../components/usuarios/ListaUsuarios";
import FormularioClientes from "../components/usuarios/FormularioClientes";
import DialogExcluir from "../components/usuarios/DialogExcluir";

export default {
  components: {
    "c-lista-usuarios": ListaUsuarios,
    "c-formulario-clientes": FormularioClientes,
    "c-dialog-excluir": DialogExcluir
  },
  data: () => ({
    baseUrl: "api/v1/clientes",
    dialog: false,
    dialogModalExcluir: false,
    loaderExcluirUsuarioCliente: false,
    headers: [
      { text: "Nome", value: "nome" },
      { text: "Domínio", value: "dominio" },
      { text: "Logins", value: "quantidadeDeLogin"},
      { text: "Configuração", value: "ambienteConfigurado" },
      {text: "Status", value: "status", align:"center", sortable: false},
      { text: "Ação", value: "acao", align: "center", sortable: false }
    ],
    cliente: [],
    clienteAtualizado: {},
    excluirUsuario: {},
    carregando: false
  }),

  created() {
    this.carregarDados(this.baseUrl);
  },

  computed: {
    txtModal: () => {
      const textoDeConfirmacao = "Tem certeza que deseja excluir este cliente? <br> Todos os seus usuários serão excluidos.";
      return textoDeConfirmacao;
    } 
  },
  methods: {
    carregarDados(url) {
      this.ciente = [];
      const headers = headersPadrao();
      this.carregando = true;
      receber(url, headers)
        .then(resposta => this.cliente = resposta)
        .catch(erro => console.error(erro))
        .finally(() => (this.carregando = false));
    },
    editarCliente(item) {
      const headers = headersPadrao();
      const CriarUrlParaEdicao = `${this.baseUrl}/${item.id}`
      receber(CriarUrlParaEdicao, headers)
        .then(resposta => this.clienteAtualizado = resposta)
        .catch(erro => {
          if(erro.request.status == 404){
            this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage)
            this.$store.commit("erro");
          }else this.$store.commit("erro", "Erro ao buscar cliente.")
        });
    },
    modalExcluir(item) {
      this.dialogModalExcluir = true;
      this.excluirUsuario = item;
    },
    apagarCliente() {
      this.loaderExcluirUsuarioCliente = true;
      const formatarUrl = `${this.baseUrl}/${this.excluirUsuario.id}`;
      const headers = headersPadrao();
      this.carregando = true;
      apagar(formatarUrl, headers)
        .then(() => {
          this.dialogModalExcluir = false;
          receber("api/v1/clientes", headers)
            .then(resposta => this.cliente = [...resposta])
            .catch(erro => console.error(erro));
        })
        .catch(erro => {
          if(erro.request.status == 400) this.$store.commit("erro", "Erro ao excluir o cliente, pois ele não existe.");
          else this.$store.commit("erro", "Erro ao excluir o cliente.")
        })
        .finally(() => {
          this.loaderExcluirUsuarioCliente = false;
          this.carregando = false;
        });
    }
  }
};
</script>
